import React from 'react';

import type { TypographyProps } from './types';
import { SecondaryStyledHeading } from './StyledComponents';

export const SecondaryHeading = ({
  children,
  testID,
  ...rest
}: TypographyProps): React.ReactElement => (
  <SecondaryStyledHeading data-testid={testID} {...rest}>
    {children}
  </SecondaryStyledHeading>
);
